import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import TranslationService from "../../../../Services/Translation/TranslationService";
import AutoTranslate from "../../../../Components/AutoTranslate";
import { Badge } from "react-bootstrap";

const Step1 = ({ stepLabels = [], onNext = () => {}, onPrev = () => {}, formData = {}, setFormData = () => {} }) => {
  const language = useSelector((state) => state.localStorage.language);
  const [healthCheck, setHealthCheck] = useState(formData.healthCheck);
  const [healthStep, setHealthStep] = useState(0);
  const [wording, setWording] = useState({
    placeholder: "상세한 답변을 입력해주세요...",
  });

  useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    const _placeholder = await TranslationService.translateText(wording.placeholder, language.lang);
    setWording({ ...wording, placeholder: _placeholder });
  };

  const handleHealthAnswer = (answer) => {
    const updatedHealthCheck = [...healthCheck];
    updatedHealthCheck[healthStep].checked = answer;
    setHealthCheck(updatedHealthCheck);
    setFormData({ ...formData, healthCheck: updatedHealthCheck });
  };

  const handleNoteChange = (note) => {
    const updatedHealthCheck = [...healthCheck];
    updatedHealthCheck[healthStep].note = note;
    setHealthCheck(updatedHealthCheck);
    setFormData({ ...formData, healthCheck: updatedHealthCheck });
  };

  // 모든 질문이 답변되었는지 확인
  const isAllAnswered = Array.isArray(healthCheck) && healthCheck.every((item) => item.checked !== "");

  return (
    <div className='flex-column-center-center gap-5 w-100'>
      <div className='step-form-container'>
        <div>
          <h2 className='step-form-title'>
            <AutoTranslate targetLanguage={language.lang}>{stepLabels[1]}</AutoTranslate>
          </h2>
          {Array.isArray(healthCheck) && healthCheck.length > 0 ? (
            <React.Fragment>
              <div className='flex-around-center'>
                {Array.isArray(healthCheck) &&
                  healthCheck.map((item, index) => {
                    return (
                      <Badge
                        key={index}
                        className='cursor-pointer'
                        pill
                        bg={`${item.checked === "" ? "white" : "success"}`}
                        text={`${item.checked === "" ? "black" : "white"}`}
                        style={{ border: `${healthStep === index ? "2px solid #03bbfe" : ""}` }}
                        onClick={() => setHealthStep(index)}
                      >
                        {index + 1}
                      </Badge>
                    );
                  })}
              </div>
              <div className='question-container'>
                <h2 className='question-title'>
                  <AutoTranslate targetLanguage={language.lang}>{healthCheck[healthStep].label}</AutoTranslate>
                </h2>
                <div className='radio-button-group'>
                  <button
                    className={`radio-button ${healthCheck[healthStep].checked !== "" ? (healthCheck[healthStep].checked === true ? "selected" : "") : ""}`}
                    onClick={() => {
                      if (healthStep < healthCheck.length - 1) {
                        setHealthStep(healthStep + 1);
                      }
                      handleHealthAnswer(true);
                    }}
                  >
                    <AutoTranslate targetLanguage={language.lang}>예</AutoTranslate>
                  </button>
                  <button
                    className={`radio-button ${healthCheck[healthStep].checked !== "" ? (!healthCheck[healthStep].checked ? "selected" : "") : ""}`}
                    onClick={() => {
                      if (healthStep < healthCheck.length - 1) {
                        setHealthStep(healthStep + 1);
                      }
                      handleHealthAnswer(false);
                    }}
                  >
                    <AutoTranslate targetLanguage={language.lang}>아니오</AutoTranslate>
                  </button>
                </div>
                {Array.isArray(healthCheck) && healthCheck[healthStep].hasNote && healthCheck[healthStep].checked && (
                  <div className='additional-answer-container'>
                    <label className='additional-answer-label'>
                      <AutoTranslate targetLanguage={language.lang}>추가 설명을 입력해주세요</AutoTranslate>
                    </label>
                    <textarea
                      className='additional-answer-input'
                      placeholder={wording.placeholder}
                      value={healthCheck[healthStep].note || ""}
                      onChange={(e) => handleNoteChange(e.target.value)}
                      rows={3}
                    />
                  </div>
                )}
              </div>
            </React.Fragment>
          ) : (
            <div className='flex-column-center-center gap-3'>
              <p>
                <AutoTranslate targetLanguage={language.lang}>관리자가 등록한 건강 면담 내용이 없습니다.</AutoTranslate>
              </p>
            </div>
          )}
        </div>
        <div className='step-button-group'>
          <button className='step-button step-button-secondary' onClick={onPrev}>
            <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
          </button>
          <button
            className={`step-button step-button-primary ${!isAllAnswered ? "disabled" : ""}`}
            onClick={() => {
              if (isAllAnswered) {
                onNext();
              }
            }}
            disabled={!isAllAnswered}
          >
            <AutoTranslate targetLanguage={language.lang}>다음</AutoTranslate>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Step1;
